// @ts-strict-ignore
import { FeedbackTagPattern } from '../model/feedback-tag-pattern';

export function getOldFeedbackPrivacyNoticeHtml(params: {
  notice: string;
  organisation: string;
  link: string;
  defaultNotice?: string;
}): string {
  const { notice, organisation, link, defaultNotice } = params;

  if (!!defaultNotice) {
    return (
      '<p>' +
      defaultNotice
        .replace(
          FeedbackTagPattern.Link,
          `<a href="${link}" target="_blank">${FeedbackTagPattern.Link.exec(defaultNotice)[2]}</a>`
        )
        .replace(FeedbackTagPattern.Org, organisation) +
      '</p>'
    );
  }

  const linkTags = [...notice.matchAll(FeedbackTagPattern.Link)];
  let noticeHtml = notice;
  linkTags.forEach((tag) => {
    noticeHtml = noticeHtml.replace(tag[0], `<a href="${link}" target="_blank">${tag[2]}</a>`);
  });
  return noticeHtml.replace(FeedbackTagPattern.Org, organisation);
}
